import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { EventService } from './event.service';
import { HWCInfo } from '../shared/model/HWCInfo.model';
import { Branch } from '../shared/model/Branch.model';
import { AS365Defaults } from '../shared/model/AS365Defaults.model';
import { SessionContextService } from './session-context.service';

@Injectable({
  providedIn: 'root',
})
export class HWCService implements OnDestroy {
  private subList: Subscription[] = [];
  private enableScanning: boolean = true;
  private HWCDisable: boolean = true;
  private hwcBranches: Branch[] = null;
  private distinctUrls: string[] = [];

  constructor(private http: HttpClient, private events: EventService, private session: SessionContextService) {
    console.log('Starting HWCService');

    this.subList.push(
      this.events.onDefaultDataChanged
        // .pipe(watch("HWC Service - onDefaultDataChanged"))
        .subscribe((r) => {
          console.log('HWCService - Default Data Changed Event');
          this.Init(r);
        })
    );

    this.subList.push(
      this.events.onHWCDisconnected
        // .pipe(watch("HWC Service - onHWCDisconnected"))
        .subscribe(() => {
          this.enableScanning = this.distinctUrls?.length > 0;
          console.log('HWC Disconnected - enable Scanning = ' + this.enableScanning);
        })
    );

    // Check for HWC every 10 seconds
    this.subList.push(
      interval(5 * 1000)
        // .pipe(watch("HWC Service - HWC URL Interval Timer"))
        .subscribe((x) => {
          if (this.HWCDisable == false && this.enableScanning && this.distinctUrls && this.distinctUrls.length > 0) {
            const headers = { 'Content-Type': 'application/json' };            
            this.distinctUrls.forEach((url) => {
              console.log('Scanning for HWC at ' + url);
              this.http.get<HWCInfo>(url + '/api/GetHWCDeviceInfo', { headers }).subscribe((hwcInfoResponse:HWCInfo) => {                
                if (hwcInfoResponse) {
                  var hwcInfo:HWCInfo =new HWCInfo(hwcInfoResponse);
                  if (hwcInfo.CustomerUId == session.defaultData.defData.TenantUid) {
                    console.log('HWC found at ' + url);
                    console.log('Disabling scanning');
                    this.enableScanning = false;
                    hwcInfo.HWCUrl = url; // Save url to HWC as needed later to allow signalR client to connect to  SignalR Server on HWC
                    hwcInfo.TillDrawers.forEach((i) => (i.BranchUID = hwcInfo.BranchUId));
                    this.events.HWCFound(hwcInfo);
                  } else {
                    console.log('Found HWC but not configured for this Customer');
                    this.enableScanning = true;
                  }
                }
              });
            });
          } else if (this.distinctUrls.length < 1) {
            this.Init(this.session.defaultData.defData);
          }
        })
    );
  }

  Init(r: AS365Defaults): void {
    if (r) {
      console.log('HWCService - updating hwc URLs');
      this.hwcBranches = r.Branches.filter((i) => i.BranchHasHWCDongle);
      if (this.hwcBranches.length == 0) {
        this.HWCDisable = true;
        return;
      }
      this.HWCDisable = false;
      var urls: string[] = [];
      this.hwcBranches.forEach((b) => {
        b.HWCWebApiUrl.split(';').forEach((urlSplitItem) => urls.push(urlSplitItem));
      });
      this.distinctUrls = urls.filter((thing, i, arr) => arr.findIndex((t) => t === thing) === i);
      this.enableScanning = this.distinctUrls?.length > 0;
      console.log('Branch Data updated - enable Scanning = ' + this.enableScanning);
      this.distinctUrls.forEach((u) => console.log('HWC URL : ' + u));
    } else this.enableScanning = false;
  }

  ngOnDestroy() {
    if (this.subList) {
      this.subList.forEach((s) => s?.unsubscribe());
      this.subList = [];
    }
  }
}
